module.exports = __webpack_public_path__ + "img/removeday.01219aa6.svg";